module.exports = __webpack_public_path__ + "img/step5-fr.fe872262.webp";